import "./Header.scss";

import { toAbsoluteUrl } from "../../../../../_metronic/helpers";

const Header: React.FC = () => {
  return (
    <div className="app-container-inner-wrapper playground-header d-flex justify-content-between align-items-center ">
      <div className="playground-logo">
        <img
          src={toAbsoluteUrl("media/logos/tc-logo-dark.svg")}
          alt="Touchcast"
          className="logo-dark"
        />
        <img
          src={toAbsoluteUrl("media/logos/tc-logo-light.svg")}
          alt="Touchcast"
          className="logo-light"
        />
      </div>
    </div>
  );
};

export { Header };
